import React from 'react';
import './view.less';

/**
 * @class CnSmartForm
 * @description 
 */
export default class CnSmartForm extends React.Component {
  static displayName = 'CnSmartForm';

  constructor(props) {
    super(props);
  }

  render() {
    return this.props.children;
  }
}
